import { Controller } from '@hotwired/stimulus';

// Keeps a form's hidden field in step with the Bootstrap pill the user is on, so a save can
// redirect back to that pill instead of the first one. The server renders the page open on
// the pill named by the same param.
//
// Targets:
//   input - the hidden field submitted with the form
// Actions:
//   select - on each pill link (data-active-subtab-name-param = the pill's name)
export default class extends Controller {
  static targets = ['input'];

  select(event) {
    this.inputTarget.value = event.params.name;
  }
}
